import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'Utils/selectors';

import { BillingInfo, PlanSection, PostBillingInfo, TrialInfo } from './components';

export const SecondStepInfo = () => {
  const { showTrialStep } = useSelector(selectUser);
  return (
    <section className="sign-up-second-step__info-wrapper">
      <PlanSection />
      {showTrialStep ? <BillingInfo /> : <PostBillingInfo />}
      <TrialInfo />
    </section>
  );
};
